<template>
<v-container fluid id="surveyContainer">
  <v-layout column wrap>
    <v-flex>
      <v-card class="elevation-1" v-if="survey" id="surveyElement">
        <survey :survey='survey'/>
      </v-card>
    </v-flex>

    <v-flex v-if="result" style="margin-top: 24px; padding: 0;" class="text-xs-center">
        <v-card style="padding: 24px;">
          <div id="surveyResult" ><h3>{{result}}</h3></div>
        </v-card>
        <br>
    </v-flex>

    <v-flex v-if="passedAndSaved">
      <v-card style="margin-top: 24px;">
        <v-layout column style="padding: 0 24px 24px 24px;">
          <v-flex>
            <h3>Übersicht</h3>
          </v-flex>
          <v-flex
            v-for="(solved, index) in questionEvaluation"
            :key="index"
            class="answer"
            style="border-top: 1px solid rgba(50,50,200, 0.7);"
          >
            <v-layout row fill-height align-center>
              <v-flex shrink
              >
                <template v-if="solved[0]">
                  <v-tooltip right open-delay="600">
                    <template v-slot:activator="{ on }">
                      <v-avatar tile color="green">
                        <v-icon dark v-on="on">check</v-icon>
                      </v-avatar>
                    </template>
                    <span>Richtig</span>
                  </v-tooltip>
                </template>
                <template v-else-if="solved[0]==false">
                  <v-tooltip right open-delay="600">
                    <template v-slot:activator="{ on }">
                      <v-avatar tile color="red">
                        <v-icon dark v-on="on">clear</v-icon>
                      </v-avatar>
                    </template>
                    <span>Falsch</span>
                  </v-tooltip>
                </template>
                <template v-else>
                  <v-tooltip right open-delay="600">
                    <template v-slot:activator="{ on }">
                      <v-avatar tile color="grey">
                        <v-icon dark v-on="on">clear</v-icon>
                      </v-avatar>
                    </template>
                    <span>Nich beantwortet</span>
                  </v-tooltip>
                </template>
              </v-flex>

              <v-flex shrink style="margin-left: 24px;">
                <template v-if="solved[0]==true || solved[0]==null">
                    <div>{{index+1}}. {{solved[1]}}</div>
                </template>
                <template v-else>
                  <span>{{index+1}}.</span>
                  {{solved[1]}}
                  <div>Korrekte Antwort(en): {{solved[2]}}</div>
                </template>
              </v-flex>
            </v-layout>      
          </v-flex>
        </v-layout>
      </v-card>
      
        <v-layout row style="margin-bottom: 14px;">
          <v-flex 
            xs6 offset-xs6
            sm4 offset-sm8
            md3 offset-md9
            lg2 offset-lg10
          >
            <v-btn  
              block
              color="white"
              @click="$router.push({ name: 'Dashboard', params: { clientId: $route.params.clientId ? $route.params.clientId : undefined } })"
            >
              Zum Dashboard
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import * as SurveyVue from "survey-vue"
import {Timer} from '../plugins/timer';

SurveyVue.StylesManager.applyTheme('default');
var Survey = SurveyVue.Survey

export default {
  props: ['content', 'shuffle'],
  name: 'quiz',
  components: {
    'survey': Survey
  },
  data: () => ({
    survey: null,
    result: null,
    passedAndSaved: false,
    questionEvaluation: [],
    sumQuestions: 0,
    correctAnswers: 0
  }),
  methods: {
    setCompletedSurvey() {
      let self = this
      this.axios.axiosCall({
          url: actionUrl + "rest/courses/complete/" + this.$route.params.courseId,
          data: {
            clientId: this.$store.state.currentClient.clientId
          },
          blockGui: false,
          success: function(response) {
              console.log(response.data)
              self.passedAndSaved = true
          }
      })
    },
    saveLog(timeSpent, result) {
      let self = this
      this.axios.axiosCall({
          url: actionUrl + "rest/log/survey",
          data: {
            courseId: this.$route.params.courseId,
            timeSpent,
            clientId: this.$store.state.currentClient.clientId,
            result
          },
          blockGui: false,
          success: function(response) {
          }
      })
    },
    shuffleArray(array, exlude) {
      const copy = array.filter( (e, i) => !exlude.includes(i));
      
      for (let i = copy.length - 1; i > 0; i--) {
        let j = Math.floor(Math.random() * (i + 1));
        [copy[i], copy[j]] = [copy[j], copy[i]];
      }

      exlude.forEach( i => {
        copy.splice(i, 0, array[i])
      })
      return copy;
    },
    checkAnswers(result) {
      console.log(result)
      var noAnswerGiven = false
      for(let page of result.pages) {
        for(let element of page.elements) {
          switch(typeof element.correctAnswer) {   
            case 'string':
              if(page.data.data[element.name] == element.correctAnswer) {
                this.correctAnswers++
                this.questionEvaluation.push([true, element.title, [null]])
              } else if (page.data.data[element.name] == null) {
                this.questionEvaluation.push([null, element.title, [null]])
              } else {
                this.questionEvaluation.push([false, element.title, [element.correctAnswer]])
              }
              break;
            case 'object':
              var allRight = 0 
              var answerList = []
              for(let cAnswer of element.correctAnswer) {
                answerList.push(cAnswer)
                if(typeof page.data.data[element.name] == "object" && Object.keys(page.data.data).length != 0) {
                  for(let answer of page.data.data[element.name]) {
                    if(answer == cAnswer) allRight++
                  } 
                } else {
                    noAnswerGiven = true
                }
              }
              if(allRight == element.correctAnswer.length) {
                this.correctAnswers++
                this.questionEvaluation.push([true, element.title, [null]])
              } else {
                if (noAnswerGiven) {
                  this.questionEvaluation.push([null, element.title, [null]])
                } else {
                  this.questionEvaluation.push([false, element.title, answerList])
                }
              }
              break;
            case 'undefined':     
              console.log("type of the correct answer is undefined")
              break;
            default: 
              console.log("no known type")

          }   
        }
      }
    }
  },
  mounted() {
    /*this.axios.axiosCall({
          url: actionUrl + "rest/courses/complete/" + this.$route.params.courseId,
          data: {},
          blockGui: false,
          success: function(response) {
              console.log(response.data)
              self.passedAndSaved = true
          }
      })*/
    
    let content = JSON.parse(this.content)

    if(this.shuffle) content.pages = this.shuffleArray(content.pages, [0, content.pages.length-1])

    content.completedHtml = ""
    this.survey = new SurveyVue.Model(content);
    this.survey.pages.questionsOrder = "initial"
    this.survey.showProgressBar = 'bottom'

    let self = this;

    this.survey.onComplete.add(survey => {
      survey.stopTimer();
      //console.log(survey)

      self.checkAnswers(survey)

      for (let i = 0; i < survey.getQuizQuestions().length; i++) {
        if (survey.getQuizQuestions()[i].name != undefined) self.sumQuestions++;
      }
      var perc= self.correctAnswers/self.sumQuestions;

      const passed = perc<0.5;

      if(passed){
        self.result = "Leider nicht bestanden."
        self.passedAndSaved = true
      } else {
        self.result = "Glückwunsch, Sie haben bestanden."
        self.setCompletedSurvey()
      }

      self.saveLog(survey.timeSpent, {"percent":perc, "passed": !passed})

      self.result +=  " Sie haben " + self.correctAnswers + " von " + self.sumQuestions + " richtig beantwortet. ";
      //self.$emit("onSurveyStarted", false)
    });

    this.survey.onStarted.add(survey => {
      self.$emit("onSurveyStarted", true)
      survey.startTimer();

    })
  } 
}
</script>

<style scoped>

h3 {
  font-weight: bold;
  font-size: 1.5em;
  text-align: left;
  color: rgb(109, 112, 114);
  padding: 16px 0;
}

#surveyResult h3 {
  text-align: center;
}
.container {
    padding: 0;
}

.answer {
  padding: 7px 4px !important;
}

.answer:hover {
  background-color: rgba(0,0,0,0.05)
}
</style>
<style>
.sv_main{
  font-size: 1.2rem !important;
}

.sv_main.sv_default_css input[type="button"], .sv_default_css button {
  background-color: #0051ce !important;
  will-change: box-shadow;
  padding: 0 16px;
  align-items: center;
  border-radius: 2px;
  height: 36px;
  margin: 6px 8px;
  min-width: 88px;
  justify-content: center;
  vertical-align: middle;
  -webkit-box-shadow: 0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12);
  box-shadow: 0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12);
}

.sv_main.sv_default_css input[type="button"]:active, .sv_default_css button:active {
  box-shadow: 0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12);
}

.sv_main.sv_default_css input[type="button"]:focus, .sv_default_css button:focus {
  outline: none;
}

.sv_main.sv_default_css input[type="button"]:hover, .sv_default_css button:hover {
    background-color: #4977c5 !important;
}

.sv_main.sv_default_css .sv_body {
  background-color: white !important;
  border-color: #0051ce !important;
}

.sv_main .sv_container .sv_header h3 span {
  font-weight: bold;
  font-size: 1em;
}

.sv_main.sv_default_css .sv_p_root > .sv_row,
.sv_main.sv_default_css .sv_custom_header,
.sv_main.sv_default_css {
  background-color: white !important;
}

.sv_main.sv_default_css .sv_p_root > .sv_row {
  border: none;
}
.sv_main .sv_container .sv_body {
  padding-bottom: 48px;
}
</style>
